import React from "react";

const WhatsappCom = () => {
    return (
        <div></div>
    )
}
export default WhatsappCom